export default __webpack_public_path__ + "static/media/img4blog.c7102667.jpg";